import React from "react";
import Slider from "react-slick";
import { MINISTERS_DATA } from "../front.constant";
import Image from "react-bootstrap/Image";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa"; // arrows

function NextArrow(props) {
  const { className, onClick } = props;
  return (
    <div className={`${className} custom-arrow next`} onClick={onClick}>
      <FaChevronRight />
    </div>
  );
}

function PrevArrow(props) {
  const { className, onClick } = props;
  return (
    <div className={`${className} custom-arrow prev`} onClick={onClick}>
      <FaChevronLeft />
    </div>
  );
}

function OurMinistersSlider() {
  const settings = {
    dots: true,
    infinite: true,
    speed: 400,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />
  };

  return (
    <div className="front-slider-wrapper">
      <h2 className="heading">Our Ministers</h2>
      <Slider {...settings}>
        {MINISTERS_DATA.map((i, index) => {
          const image = i.smallImage;
          return (
            <div className="item" key={index}>
              <div className="img-wrap">
                <Image src={image.url} alt={image.alt} loading="lazy" />
              </div>
              <div
                className={`text ${
                  i.description !== undefined ? "has-quote" : ""
                }`}
              >
                <h2>{i.name}</h2>
                <h4>{i.designation}</h4>
                {i.description && (
                  <div className="qoute">
                    <p>{i.description}</p>
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </Slider>
    </div>
  );
}

export default OurMinistersSlider;
